import {useEffect, useMemo} from 'react'
import {useLenis} from 'lenis/react'

/**
 * Use to lock and unlock body scrolling when some overlay is displayed
 * @param {boolean} [lock] - should the scroll be locked
 * @returns {{lock: function(): void, unlock: function(): void}}
 */
function useScrollLock(lock) {
    // cancel lenis if available when drawer is open to prevent scrolling the body
    const lenis = useLenis()
    useEffect(() => {
        if (!lenis) {
            return
        }
        if (lock) {
            lenis.stop()
        } else {
            lenis.start()
        }
    }, [lenis, lock])

    return useMemo(
        () => ({
            lock: () => lenis.stop(),
            unlock: () => lenis.start()
        }),
        [lenis]
    )
}

export default useScrollLock
